import Mock from 'mockjs'
import activity from './activity'

const enableMock = process.env.VUE_APP_ENABLE_MOCK === 'true'

if (enableMock) {
  activity.forEach(item => {
    Mock.mock(
      new RegExp(`${process.env.VUE_APP_BASE_API || ''}${item.url}`),
      item.type,
      item.response
    )
  })

  Mock.setup({
    timeout: '200-600'
  })

  console.log('[Mock] Mock server enabled (npm run dev:mock)')
  console.log('[Mock] 活动入口 /a/1 ，示例学生序列号 123456789012345678')
}

export default Mock



// WEBPACK FOOTER //
// ./src/mock/index.js